<template>
  <div>
    <label>{{ label }}</label>
    <p class="error_field" v-if="error.length">{{ error }}</p>
    <input type="file" placeholder="Выберите изображение" @change="onFileChange($event)">
  </div>
</template>

<script>
// assets/project/src/components/Base/BaseImageUpload.vue
export default {
  name: "BaseImageUpload",
  data() {
    return {
    }
  },
  props: [
    "label",
    "error"
  ],
  methods: {
    onFileChange($event) {
      const file = $event.target.files[0];
      this.$emit('onFileChange', file);
    }
  }
}
</script>

<style scoped>
.error_field {
  color: red;
}
</style>